import { render, staticRenderFns } from "./popup-record.vue?vue&type=template&id=a96673de&scoped=true"
import script from "./popup-record.vue?vue&type=script&lang=js"
export * from "./popup-record.vue?vue&type=script&lang=js"
import style0 from "./popup-record.vue?vue&type=style&index=0&id=a96673de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96673de",
  null
  
)

export default component.exports